import options from './data-connector.component';

export default {
    selector: 'dtDataConnectorDetailsPage',
    options
};
